// submissionListener.js
import { auth } from "../../../../backend/firebaseConfig";
import { db } from "../../../../backend/firebaseConfig"; // Import your Firebase config
import { doc, getDoc, setDoc } from "firebase/firestore";

let isSubmitted = false;
const listeners = new Set();

// Function to initialize submission status with Firestore snapshot listener
const initializeSubmissionStatusListener = async () => {
  const user = auth.currentUser;
  try {
    const docRef = doc(db, "Advisers", user.uid, "Personal Details", "Data");
    const docSnap = await getDoc(docRef);
    //   console.log(docSnap.data().recruitmentApplication);
    // Set up a Firestore listener to keep isSubmitted up-to-date
    if (docSnap.exists()) {
      isSubmitted = docSnap.data().recruitmentApplication || false;
      notifyListeners();
    }
  } catch (error) {
    // console.log("Error getting document:", error);
  }
};

// Initialize the Firestore listener
initializeSubmissionStatusListener();

// Function to get the current submission status
export const getIsSubmitted = () => {
  initializeSubmissionStatusListener();
  return isSubmitted;
  notifyListeners();
};

// Add listener to be notified of changes
export const addSubmissionListener = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener); // Remove listener on cleanup
};

// Notify all listeners of the updated submission status
const notifyListeners = () => {
  listeners.forEach((listener) => listener(isSubmitted));
};
